'use client';

import { useState, useEffect } from 'react';

import { v4 as uuidv4 } from 'uuid';

import AlternativeCard from '@/stories/organisms/cardCarousel/CardCarousel';

import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';

import { CardJackpots } from './components/CardJackpots';
import { CardReferalsAdapter } from './components/CardReferalsAdapter';
import CardSportTournamet from './components/CardSportTournamet';

export const CardsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleIndicatorClick = (index: number) => {
    setCurrentIndex(index);
  };

  if (!isMounted) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-hprimary-500" />
      </div>
    );
  }

  const cards = [
    <AlternativeCard
      key="trending"
      style={{
        backgroundImage: 'url(/img/v2/home/pagesPromotions/referred.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'rgba(17, 24, 28, 0.5)',
        backgroundBlendMode: 'multiply',
      }}
      totalItems={3}
      currentIndex={currentIndex}
      onIndicatorClick={handleIndicatorClick}
    >
      <CardReferalsAdapter />
    </AlternativeCard>,
    <AlternativeCard
      key="community"
      style={{
        backgroundImage: 'url(/img/v2/home/pagesPromotions/jackpots.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'rgba(17, 24, 28, 0.5)',
        backgroundBlendMode: 'multiply',
      }}
      totalItems={3}
      currentIndex={currentIndex}
      onIndicatorClick={handleIndicatorClick}
    >
      <CardJackpots />
    </AlternativeCard>,
    <AlternativeCard
      key="tournaments"
      style={{
        backgroundImage: 'url(/img/v2/home/pagesPromotions/torneoDeportes.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'right',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'rgba(17, 24, 28, 0.5)',
        backgroundBlendMode: 'multiply',
      }}
      totalItems={3}
      currentIndex={currentIndex}
      onIndicatorClick={handleIndicatorClick}
    >
      <CardSportTournamet />
    </AlternativeCard>,
  ];

  return (
    <div className="flex justify-center mt-8 md:mt-10 md:mx-auto ">
      <div className="flex w-full md:justify-center mx-4 md:mx-auto">
        <div className="flex md:justify-center w-full mx-4  md:mx-auto">
          <Carousel
            className="w-full md:w-auto md:max-w-8xl md:flex md:justify-center"
            opts={{
              align: 'start',
              dragFree: true,
              containScroll: 'trimSnaps',
              slidesToScroll: 1,
            }}
          >
            <CarouselContent className="flex flex-row gap-3 justify-start">
              {cards.map((card) => {
                return (
                  <CarouselItem key={uuidv4()} className="max-w-80 max-h-80 basis-80 flex-shrink-0">
                    {card}
                  </CarouselItem>
                );
              })}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </div>
  );
};
